module.exports = __webpack_public_path__ + "static/media/help logo.bbca43d3.svg";